<template>
  <div class="member-account-set" v-if="user">
    <div class="common-header-wrap">
      <mt-header :title="$t('Account Settings')" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="main-content">
      <div class="menu-list">
        <div v-show="(user.member_mobilebind && user.member_mobile) || (user.member_emailbind && user.member_email)"
          @click='popupVisible("password")'>
          <flex-line class="menu-item" :is-link="true" :show-border="true">
            <span class="line-name">{{ $t('Change Login Password') }}</span>
          </flex-line>
        </div>
        <div v-show="(user.member_mobilebind && user.member_mobile) || (user.member_emailbind && user.member_email)"
          @click='popupVisible("paypwd")'>
          <flex-line class="menu-item" :is-link="true" :show-border="true">
            <span class="line-name">{{ $t('Change Payment Password') }}</span>
          </flex-line>
        </div>
        <div @click='popupVisible("mobile")'>
          <flex-line class="menu-item" :is-link="true" :show-border="true">
            <span class="line-name">{{ (user.member_mobilebind ? $t('Modify') : $t('Bind')) + $t(' Mobile') }}</span>
            <span slot="right">{{ user.member_mobile }}</span></flex-line>
        </div>
        <div @click='popupVisible("email")'>
          <flex-line class="menu-item" :is-link="true" :show-border="true">
            <span class="line-name">{{ (user.member_emailbind ? $t('Modify') : $t('Bind')) + $t(' Email') }}</span>
            <span slot="right">{{ user.member_email }}</span>
          </flex-line>
        </div>
      </div>
      <div class="pt-10 pb-10">
        <div class="common-btn ds-button-large" @click="logout">{{ $t('Log Out') }}</div>
      </div>
    </div>

    <!-- Modify Mobile -->
    <mt-popup v-model="editMobileVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header :title="(user.member_mobilebind ? $t('Modify') : $t('Bind')) + $t(' Mobile')" class="common-header">
          <mt-button slot="left" icon="back" @click="editMobileVisible = false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
        <flex-line class="field-line menu-item" :show-border="true"><span class="field-name">{{ $t('Mobile') }}</span>
          <div class="field-line-right" slot="right"><input class="field-input" v-model="mobile" type="number"
              :attr="{ oninput: 'if(value.length>11)value=value.slice(0,11)' }" /></div>
        </flex-line>
        <flex-line class="field-line" :show-border="true"><span class="field-name">{{ $t('Verification Code') }}</span>
          <div class="field-line-right" slot="right"><input class="field-input" v-model="verifyCodeMobile" type="number"
              :attr="{ oninput: 'if(value.length>6)value=value.slice(0,6)' }" />
            <div @click="sendVerifyCodeMobile" class="common-btn send-btn">{{ sendStateTextMobile }}</div>
          </div>
        </flex-line>
        <div class="common-btn ds-button-large mt-10" @click='updateMobile'>{{ $t('Submit') }}</div>
      </div>
    </mt-popup>

    <!-- Modify Email -->
    <mt-popup v-model="editEmailVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header :title="(user.member_emailbind ? $t('Modify') : $t('Bind')) + $t(' Email')" class="common-header">
          <mt-button slot="left" icon="back" @click="editEmailVisible = false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
        <flex-line class="field-line menu-item" :show-border="true"><span class="field-name">{{ $t('Email') }}</span>
          <div class="field-line-right" slot="right"><input class="field-input" v-model="email" /></div>
        </flex-line>
        <div class="common-btn ds-button-large mt-10" @click="sendVerifyCodeEmail">{{ $t('Submit') }}</div>
      </div>
    </mt-popup>

    <!-- Change Login Password -->
    <mt-popup v-model="editPasswordVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header title="Change Login Password" class="common-header">
          <mt-button slot="left" icon="back" @click="editPasswordVisible = false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
        <flex-line class="field-line menu-item" :show-border="true"><span class="field-name">{{ $t('New Password')
        }}</span>
          <div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="password1" />
          </div>
        </flex-line>
        <flex-line class="field-line menu-item" :show-border="true">
          <span class="field-name">
            {{ $t('Confirm Password') }}
          </span>
          <div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="password2" />
          </div>
        </flex-line>
        <div class="common-btn ds-button-large mt-10" @click='updatePassword'>{{ $t('Submit') }}</div>
      </div>
    </mt-popup>

    <!-- Change Payment Password -->
    <mt-popup v-model="editPaypwdVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header title="Change Payment Password" class="common-header">
          <mt-button slot="left" icon="back" @click="editPaypwdVisible = false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
        <flex-line class="field-line menu-item" :show-border="true"><span class="field-name">{{ $t('New Password')
        }}</span>
          <div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="paypwd1" /></div>
        </flex-line>
        <flex-line class="field-line menu-item" :show-border="true"><span class="field-name"> {{ $t('Confirm Password')
        }}</span>
          <div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="paypwd2" /></div>
        </flex-line>
        <div class="common-btn ds-button-large mt-10" @click="updatePaypwd">{{ $t('Submit') }}</div>
      </div>
    </mt-popup>

    <mt-popup v-model="sendAuthCode" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header title="Identity Verification" class="common-header">
          <mt-button slot="left" icon="back" @click="sendAuthCode = false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
        <common-send-code @checkSuccess="checkSuccess" />
      </div>
    </mt-popup>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
import { logout, getMemberInfo } from '../../../api/member'
import CommonSendCode from '../common/CommonSendCode'
import { updateUserMobile, updateUserPassword, updateUserPaypwd, bindUserMobile, bindUserEmail } from '../../../api/memberSetting'
import flexLine from '../../flexLine'
export default {
  components: {
    flexLine,
    CommonSendCode
  },
  name: 'MemberSetting',
  data() {
    return {
      sendAuthCode: false,
      authType: 'mobile',
      editPaypwdVisible: false,
      paypwd1: '',
      paypwd2: '',
      editMobileVisible: false,
      mobile: '',
      editEmailVisible: false,
      email: '',
      editPasswordVisible: false,
      password1: '',
      password2: '',
      verifyCodeMobile: '',
      canSendMobile: true,
      timeIntervalMobile: false,
      sendStateTextMobile: 'send',
      canSendEmail: true,
      timeIntervalEmail: false,
      sendStateTextEmail: 'send'

    }
  },
  beforeDestroy: function () {
    clearInterval(this.timeIntervalMobile)
    clearInterval(this.timeIntervalEmail)
  },
  created: function () {
    getMemberInfo().then(res => {
      this.memberUpdate({ info: res.result.member_info })
      if (!res.result.member_info.member_emailbind) { // 如果没有绑定邮箱则输入项自动填写上次的邮箱
        this.email = res.result.member_info.member_email
      }
      if (!res.result.member_info.member_mobilebind) { // 如果没有绑定手机则输入项自动填写上次的手机
        this.mobile = res.result.member_info.member_mobile
      }
    }, error => { }
    )
  },
  computed: {
    ...mapState({
      user: state => state.member.info
    })
  },
  methods: {
    ...mapMutations({
      memberUpdate: 'memberUpdate',
      memberEdit: 'memberEdit',
      memberLogout: 'memberLogout'
    }),
    logout() {
      logout(this.user.member_name).then(res => {
        this.memberLogout()
        this.$router.push({ name: 'HomeMemberLogin' })
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    popupVisible(authType) {
      this.authType = authType
      switch (authType) {
        case 'mobile':
          if (this.user.member_mobilebind && this.user.member_mobile) { // 已绑定手机则需要验证
            this.sendAuthCode = true
          } else {
            this.editMobileVisible = true
          }
          break
        case 'email':
          if (this.user.member_emailbind && this.user.member_email) { // 已绑定邮箱则需要验证
            this.sendAuthCode = true
          } else {
            this.editEmailVisible = true
          }
          break
        case 'password':
          this.sendAuthCode = true
          break
        case 'paypwd':
          this.sendAuthCode = true
          break
      }
    },
    checkSuccess() {
      switch (this.authType) {
        case 'mobile':
          this.editMobileVisible = true
          break
        case 'email':
          this.editEmailVisible = true
          break
        case 'password':
          this.editPasswordVisible = true
          break
        case 'paypwd':
          this.editPaypwdVisible = true
          break
      }
    },
    // 更改绑定手机号
    updateMobile() {
      updateUserMobile(this.verifyCodeMobile).then(res => {
        this.memberEdit({ member_mobile: this.mobile, member_mobilebind: 1 })
        Toast(res.message)
        this.$router.go(0)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    // 更改登录密码
    updatePassword() {
      updateUserPassword(this.password1, this.password2).then(res => {
        Toast(res.message)
        this.$router.go(0)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    // 更改支付密码
    updatePaypwd() {
      updateUserPaypwd(this.paypwd1, this.paypwd2).then(res => {
        Toast(res.message)
        this.$router.go(0)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    // send手机验证码
    sendVerifyCodeMobile() {
      if (!this.canSendMobile) {
        return
      }
      bindUserMobile(this.mobile).then(res => {
        this.memberEdit({ member_mobile: this.mobile, member_mobilebind: 0 })
        this.canSendMobile = false
        let second = 60
        Toast(res.message)
        let _this = this
        this.timeIntervalMobile = setInterval(function () {
          if (second <= 0) {
            _this.canSendMobile = true
            _this.sendStateTextMobile = 'send'
            clearInterval(_this.timeIntervalMobile)
          } else {
            _this.sendStateTextMobile = second + 's'
          }

          second--
        }, 1000)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    // send邮箱验证码
    sendVerifyCodeEmail() {
      if (!this.canSendEmail) {
        return
      }
      bindUserEmail(this.email).then(res => {
        this.memberEdit({ member_email: this.email, member_emailbind: 0 })
        this.canSendEmail = false
        let second = 60
        Toast(res.message)
        let _this = this
        this.timeIntervalEmail = setInterval(function () {
          if (second <= 0) {
            _this.canSendEmail = true
            _this.sendStateTextEmail = 'send'
            clearInterval(_this.timeIntervalEmail)
          } else {
            _this.sendStateTextEmail = second + 's'
          }

          second--
        }, 1000)
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>

<style  lang="scss" scoped>
.main-content {
  background: #fff;
  padding: 0 $pageSpace
}

.common-popup-content {
  padding: 0 $pageSpace;
  box-sizing: border-box
}

.send-btn {
  border: 1px solid $primaryColor;
  color: $primaryColor;
  min-width: 2rem
}

.member-account-set {
  position: relative;
  z-index: 100;

  .menu-list {
    .menu-item {
      .right-arrow {
        transform: rotate(-90deg);
        color: #ddd;
        font-size: $fontSize;
      }
    }
  }
}
</style>
